import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { Text, TextStyles } from "@cinch-labs/design-system";
import cx from "classnames";
import { LOADING_TEXT } from "../../constants";
import skeletonStyles from "../skeleton.module.css";
export var Title = function(_param) /*#__PURE__*/ {
    var children = _param.children, _isPending = _param.isPending, isPending = _isPending === void 0 ? false : _isPending, type = _param.type, _className = _param.className, className = _className === void 0 ? "" : _className, _element = _param.element, element = _element === void 0 ? "h5" : _element, props = _object_without_properties(_param, [
        "children",
        "isPending",
        "type",
        "className",
        "element"
    ]);
    return _jsx(Text, _object_spread_props(_object_spread({
        element: element,
        className: cx(skeletonStyles.base, _define_property({}, skeletonStyles.active, isPending), className),
        type: type || TextStyles.mainTitle
    }, props), {
        children: isPending ? LOADING_TEXT : children
    }));
};
export default Title;
